
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/service-management/plan",
      function () {
        return require("private-next-pages/service-management/plan/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/service-management/plan"])
      });
    }
  